import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "menu_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM23 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
    }, null, -1)
  ]))]))
}
export default { render: render }